module.exports = __webpack_public_path__ + "img/auto.debe5386.png";